/**
 * Expand-Collapse Content.
 * 
 */

/**
 * Desktop: Click to expand/collapse.
 * Mobile: Click to expand/collapse.
 */

let 
	$window = $(window),
	$excolButtons = $('.ex-col-button'),
	$myBtn,
	$myContent,
	$currBtn,
	$currContent;

function initExColButtons() {
	// console.log('COMPONENT: initExColButtons()');

	$excolButtons.on('click', function() {
		// console.log('CLICK: '+$(this));
		$myBtn = $(this);
		$myContent = $myBtn.next();
		$currBtn = $excolButtons.filter('.expanded');
		$currContent = $currBtn.next();
		if ($myBtn.hasClass('expanded')) {
			// Collapse this Value.
			$myBtn.removeClass('expanded');
			$myContent.slideUp(300);
		} else {
			// Collapse current expanded Value, expand this value.
			$currBtn.removeClass('expanded');
			$currContent.slideUp(300);
			$myBtn.addClass('expanded');
			$myContent.slideDown(300);
		}
	});
}

exports.init = function () {
	// console.log('COMPONENT: exports.init');
	// Run init methods...

	initExColButtons();
};
